module.exports = __webpack_public_path__ + "img/home.3b3e33d2.png";